import { unlockTherapistConstant } from 'src/redux/actions/constant';

const {
  GET_LOCK_DAILY_SESSION_NOTES_REQUEST,
  GET_LOCK_DAILY_SESSION_NOTES_SUCCESS,
  GET_LOCK_DAILY_SESSION_NOTES_FAILURE,
  GET_LOCK_DAILY_SESSION_NOTES_RESET,
  GET_LOCK_DAILY_SESSION_NOTES_LOADING,
} = unlockTherapistConstant;

const intialState: object = {
  response: null,
  isGetLockDailyNote: false,
  loading: false,
};

export const getLockDailySessionNote = (state = intialState, action: any) => {
  switch (action.type) {
    case GET_LOCK_DAILY_SESSION_NOTES_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isGetLockDailyNote: true,
        loading: false,
      };
    }
    case GET_LOCK_DAILY_SESSION_NOTES_FAILURE: {
      return {
        ...state,
        response: action.payload,
        isGetLockDailyNote: false,
        loading: false,
      };
    }

    case GET_LOCK_DAILY_SESSION_NOTES_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_LOCK_DAILY_SESSION_NOTES_RESET:
      return intialState;

    default:
      return state;
  }
};
